import React from 'react';
const Input = React.memo((props) => {
    var _a, _b, _c;
    let classes = (_a = props.classes) !== null && _a !== void 0 ? _a : [];
    classes = ['focus:outline-none', 'focus:border-red-400', 'form-input', 'bg-gray-100', ...classes];
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { className: classes.join(" "), type: props.inputType, name: props.name, value: props.inputValue, onChange: props.onChange, onFocus: props.onFocus, onBlur: props.onBlur, disabled: props.disabled, placeholder: (_b = props.placeholder) !== null && _b !== void 0 ? _b : "", pattern: (_c = props.pattern) !== null && _c !== void 0 ? _c : "" })));
});
export default Input;
